import { pushEcommerceEvent } from '@app/infrastructure/gtm/pushEcommerceEvent';
import { GtmEventName } from '@app/domain/model/gtm/GtmEventName';
import { EcommerceItem } from '@app/domain/model/gtm/EcommerceItem';
import { TravelPremiumRisk } from '@app/domain/model/eshop/travel/TravelPremiumRisk';
import { getRiskItemCategory } from '@app/infrastructure/gtm/travel/getRiskItemCategory';

export function trackAddToCart(selectedRisks: TravelPremiumRisk[]): void {
    const items = selectedRisks.filter(risk => (risk.premiumAfterDiscount ?? risk.premium ?? 0) > 0);

    if (items.length === 0) {
        return;
    }

    const totalValue = items.reduce((sum, risk) => sum + (risk.premiumAfterDiscount ?? risk.premium ?? 0), 0);

    const ecommerceItems: EcommerceItem[] = items.map(risk => ({
        item_name: risk.name,
        item_id: risk.code ?? '',
        price: risk.premiumAfterDiscount ?? risk.premium ?? 0,
        item_category: getRiskItemCategory(risk.code),
        quantity: 1,
    }));

    pushEcommerceEvent(GtmEventName.AddToCart, {
        currency: 'EUR',
        value: totalValue,
        items: ecommerceItems,
    });
}
